<template>
  <CommonDialog
    v-if="isAddPaymentModalOpen"
    :isDialogOpened="isAddPaymentModalOpen"
    class="mt-2"
    width="500"
    @handleCloseDialog="toggleModal && toggleModal(false)"
  >
    <v-card class="px-1 pb-8">
      <v-card-title class="d-flex justify-end">
        <v-btn
          :disabled="isSaving"
          icon
          @click="toggleModal && toggleModal(false)"
        >
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form ref="form" v-model="isFormValid">
        <v-card-text>
          <h2
            class="add-payment-modal__heading text-center secondary--text mb-8"
          >
            Edit Payment Processor
          </h2>
          <div class="d-flex">
            <div style="width: 50%">
              <div class="fee-description">Processor Fee</div>
              <div>
                <v-tooltip :bottom="true" nudge-left="85" nudge-top="10">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <div class="learn">Learn More</div>
                    </span>
                  </template>
                  <div class="processor-tooltip">
                    Payment processors charge processing fees (ex. 2.9% + $0.70
                    per transaction). Input the processing fee you get charged.
                  </div>
                </v-tooltip>
              </div>
            </div>
            <v-text-field
              v-model="feePrice"
              class="payment-left-input"
              dense
              flat
              outlined
              prepend-inner-icon="mdi-currency-usd"
              solo
              style="width: 20%; text-align: right"
              type="number"
            />
            <v-text-field
              v-model="feePercentage"
              append-icon="mdi-percent-outline"
              class="payment-right-input"
              dense
              flat
              outlined
              solo
              style="width: 10%; text-align: right"
              type="number"
            />
          </div>
          <div
            v-if="
              selectedOrg.processingFeeInCents ||
                selectedOrg.processingFeePerMil
            "
            class="d-flex"
          >
            <div style="width: 50%">
              <div class="fee-description">TeamBot Fee</div>
              <div>
                <v-tooltip :bottom="true" nudge-left="85" nudge-top="10">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <div class="learn">Learn More</div>
                    </span>
                  </template>
                  <div class="processor-tooltip">
                    TeamBot charges a small fee to process payments
                  </div>
                </v-tooltip>
              </div>
            </div>
            <v-text-field
              :value="convertCentsToDollars(selectedOrg.processingFeeCents)"
              class="payment-left-input"
              dense
              disabled
              flat
              outlined
              prepend-inner-icon="mdi-currency-usd"
              solo
              style="width: 20%; text-align: right"
              type="number"
            />
            <v-text-field
              :value="convertPerMilToPercent(selectedOrg.processingFeePerMil)"
              append-icon="mdi-percent-outline"
              class="payment-right-input"
              dense
              disabled
              flat
              outlined
              solo
              style="width: 10%; text-align: right"
              type="number"
            />
          </div>
          <v-divider />
          <div class="d-flex mt-4">
            <div style="width: 50%">
              <div class="fee-description">Total</div>
              <div>
                <v-tooltip :bottom="true" nudge-left="85" nudge-top="10">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <div class="learn">Learn More</div>
                    </span>
                  </template>
                  <div class="processor-tooltip">
                    This is the total charged to either the customer, or the
                    club for transactions. You can decide whether to absorb
                    these costs, or let your team pay them at checkout for each
                    fee.
                  </div>
                </v-tooltip>
              </div>
            </div>
            <v-text-field
              :value="
                (
                  parseFloat(feePrice) +
                  parseFloat(
                    convertCentsToDollars(selectedOrg.processingFeeCents)
                  )
                ).toFixed(2)
              "
              class="payment-left-input"
              dense
              disabled
              flat
              outlined
              prepend-inner-icon="mdi-currency-usd"
              solo
              style="width: 20%; text-align: right"
              type="number"
            />
            <v-text-field
              :value="
                parseFloat(feePercentage) +
                  parseFloat(
                    convertPerMilToPercent(selectedOrg.processingFeePerMil)
                  )
              "
              append-icon="mdi-percent-outline"
              class="payment-right-input"
              dense
              disabled
              flat
              outlined
              solo
              style="width: 10%; text-align: right"
              type="number"
            />
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <CommonButton
            :disabled="isSaving"
            :label="$t('common.cancel')"
            class="px-4"
            color="#fff"
            width="100"
            @handleClick="toggleModal && toggleModal(false)"
          />
          <CommonButton
            :loading="isSaving"
            class="px-4"
            label="Save"
            not-capitalize
            width="100"
            @handleClick="updateProvider"
          />
        </v-card-actions>
      </v-form>
    </v-card>
  </CommonDialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import GetterTypes from "@/store/GetterTypes";
import CommonDialog from "@/views/academy/common/dialog/CommonDialog";
import CommonButton from "@/views/academy/common/CommonButton";
import {
  PaymentProvidersNames,
  PaymentProvidersTypes
} from "@/views/academy/enums/PaymentProvidersTypes";
import { i18n } from "@/plugins/i18n";
import { RegExps } from "@/views/academy/enums/RegExps";
import { ModuleTypes } from "@/store/ModuleTypes";

export default {
  name: "EditPaymentModal",
  components: {
    CommonDialog,
    CommonButton
  },
  props: {
    isAddPaymentModalOpen: {
      type: Boolean,
      required: true
    },
    toggleModal: {
      type: Function,
      required: true
    },
    paymentsAccountsChange: {
      type: Function,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    paymentProviders: [
      {
        name: PaymentProvidersNames.STRIPE,
        value: PaymentProvidersTypes.STRIPE
      },
      {
        name: PaymentProvidersNames.PAYPAL,
        value: PaymentProvidersTypes.PAYPAL
      }
    ],
    PaymentProvidersTypes,
    isFormValid: false,
    paymentProvider: "",
    email: "",
    feePrice: 0,
    feePercentage: 0,
    isSaving: false,
    orgHasProcessingSubscription: false,
    rules: {
      paymentProvider: value =>
        !!value || i18n.tc("validation.field_is_required"),
      email: value =>
        !!value?.match(RegExps.EMAIL) || i18n.tc("validation.invalid_email"),
      feePercentage: value =>
        value <= 100 || i18n.tc("validation.max_100_percent"),
      feePrice: value => {
        return (
          (value && Number.parseFloat(value)?.toFixed(2)) <= 99999 ||
          i18n.tc("validation.max_99999_number")
        );
      }
    }
  }),
  mounted() {
    this.feePercentage = this.convertPerMilToPercent(
      this.item.processingFeePerMilli
    );
    this.feePrice = this.convertCentsToDollars(this.item.processingFeeInCents);
  },

  computed: {
    ...mapGetters({
      selectedOrg: GetterTypes.GET_ORGANIZATION
    })
  },
  methods: {
    updateProvider() {
      this.paymentsAccountsChange({
        percent: this.feePercentage,
        amount: this.feePrice
      });
      this.toggleModal();
    },
    convertCentsToDollars(cents) {
      return cents ? (cents / 100).toFixed(2) : 0;
    },
    convertPerMilToPercent(perMil) {
      return perMil ? (perMil / 10).toFixed(1) : 0;
    },
    ...mapActions(ModuleTypes.TEAM_REGISTRATION, [
      "createPaymentAccount",
      "createStripeAccount",
      "createStripeOnboarding",
      "createPayPalAccount"
    ])
  }
};
</script>

<style scoped>
.processor-tooltip {
  width: 300px;
}
.fee-description {
  font-size: 14px;
  font-weight: 500;
}
.learn {
  margin-top: -6px;
  font-size: 12px;
  font-weight: 300;
  color: #1f97ff;
  cursor: pointer;
}
.add-payment-modal__heading {
  font-size: 27px;
  font-weight: var(--font-weight-semi-bold);
}

.add-payment-modal__payment-provider-select >>> .v-input__slot,
.add-payment-modal__payment-provider-input >>> .v-input__slot {
  margin-bottom: 2px;
}

.add-payment-modal__payment-provider-select >>> .v-input__slot {
  min-height: 40px;
}

.add-payment-modal__payment-provider-input >>> .v-input__slot {
  min-height: 48px;
}

.add-payment-modal__payment-provider-input >>> .v-label {
  color: #aab0bc !important;
}

.add-payment-modal__payment-provider-select >>> .v-input__append-inner {
  margin: auto 0;
}

.add-payment-modal__payment-provider-select >>> fieldset {
  border-color: var(--grey-color) !important;
}

.add-payment-modal__payment-provider-select >>> .v-text-field__details,
.add-payment-modal__payment-provider-input >>> .v-text-field__details {
  margin-bottom: 2px;
}
</style>
<style>
.payment-right-input.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot,
.v-text-field.v-text-field--enclosed .v-text-field__details {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.payment-left-input.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot,
.v-text-field.v-text-field--enclosed .v-text-field__details {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.payment-left-input.v-input__control.v-input__slot.v-input__prepend-inner.vinput__icon.v-input__icon--prepend-inner.v-icon {
  margin-left: -12px;
}

.payment-right-input.v-text-field.v-text-field--solo .v-input__control input,
.payment-left-input.v-text-field.v-text-field--solo .v-input__control input {
  text-align: end;
}
</style>
